import { Grid, Typography } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import { Split } from "../../utils/Split";
import { convertNumbers } from "../../utils/ConvertNumbers";
import Call from "../../service/API";
import { useMountAPI } from "../../hooks/APICall";
import { useEffect } from "react";
import moment from "jalali-moment";
import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  SILVER_TABLE_COLOR,
  eventRecordsPageSize,
  WHITE,
} from "../../utils/const";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Loading from "../loading"; // for loading
import Paginator from "../paginator"; // for pagination
import { useHistory } from "react-router";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: SILVER_TABLE_COLOR,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const EventTable = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const counterInfoIsLoading = useCustomState(true);
  const counterInfo = useCustomState({});

  const eventsIsLoading = useCustomState(true);
  const events = useCustomState([]);

  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination

  const history = useHistory();

  const counterUtils = {
    serial: props.serial,
    isLoading: counterInfoIsLoading,
    counterInfo: counterInfo,
  };

  const eventsUtils = {
    page: selectedPage.value, // for pagination
    count: eventRecordsPageSize, // for pagination
    isLoading: eventsIsLoading,
    events: events,
    allItems: allItems, // for pagination
  };

  useMountAPI(fetchCounterInfo, counterUtils);

  useEffect(() => {
    if (!counterInfoIsLoading.value) {
      if (counterInfo.value.moduleInfo === null) {
        eventsUtils.moduleCode = null;
      } else {
        eventsUtils.moduleCode = counterInfo.value?.moduleInfo?.code;
      }
      fetchEvents(eventsUtils);
    }
  }, [counterInfoIsLoading.value]);

  // for pagination
  const selectedPageChanged = (newPage) => {
    const moduleCode =
      counterInfo.value.moduleInfo === null
        ? null
        : counterInfo.value.moduleInfo.code;
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      eventsUtils.page = newPage;
      eventsUtils.moduleCode = moduleCode;
      eventsIsLoading.handleChange(true);
      fetchEvents(eventsUtils);
    }
  };

  const renderRecords = () => {
    return (
      <>
        {events.value.map((e, idx) => {
          const eventName = e.type.keyword;
          const eventCode = e.type.code;
          const date = moment(e.createdAt)
            .locale("fa")
            .format("YYYY/MM/DD,HH:mm:ss");
          const value = e.value;
          let importance = e.type.importance;
          const importanceStyle = {
            color: "#fff",
            backgroundColor: "green",
            fontSize: "12px",
            borderRadius: "4px",
            paddingRight: "6px",
            paddingLeft: "6px",
            marginRight: "8px",
          };
          if (importance === "H") {
            importanceStyle.backgroundColor = ERROR_COLOR;
            importance = "زیاد";
          } else if (importance === "M") {
            importanceStyle.backgroundColor = ORANGE_COLOR;
            importance = "متوسط";
          } else {
            importanceStyle.backgroundColor = GREEN_PRIMRY;
            importance = "کم";
          }
          return (
            <TableRow key={idx}>
              <TableCell component="th" scope="row">
                {convertNumbers(
                  idx + 1 + eventRecordsPageSize * (selectedPage.value - 1)
                )}
              </TableCell>
              <TableCell align="center">{convertNumbers(eventName)}</TableCell>
              <TableCell align="center">
                <span>{convertNumbers(date.split(",")[0])}</span>
                <br />
                <span>{convertNumbers(date.split(",")[1])}</span>
              </TableCell>
              <TableCell align="center">{convertNumbers(eventCode)}</TableCell>
              <TableCell align="center">
                <span style={importanceStyle}>
                  {convertNumbers(importance)}
                </span>
              </TableCell>
              <TableCell align="center">{convertNumbers(value)}</TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };

  const renderTable = () => {
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell align="center">رخداد</TableCell>
              <TableCell align="center">تاریخ ثبت</TableCell>
              <TableCell align="center">کد رخداد</TableCell>
              <TableCell align="center">میزان اهمیت</TableCell>
              <TableCell align="center">مقدار</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderRecords()}</TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={eventRecordsPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderLoading = () => {
    {
      /* 
        begin: for loading
      */
    }
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ height: "260px", position: "relative" }}
      >
        <Loading />
      </Grid>
    );
    {
      /* end: for loading */
    }
  };

  // for loading and pagination
  const renderContent = () => {
    if (!eventsIsLoading.value) {
      return (
        <>
          <Grid item sx={12} sm={12} md={12} lg={12}>
            {renderTable()}
          </Grid>
        </>
      );
    } else {
      return renderLoading();
    }
  };

  console.log(events);
  return (
    <>
      {events.value.length > 0 ? (
        <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
          <Grid item sx={12} sm={12} md={12} lg={12}>
            <Card style={{ width: "100%", marginTop: "16px" }}>
              <CardHeader
                style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
                title={"رخدادها"}
                action={
                  <ExpandMoree
                    expand={expanded.value}
                    onClick={handleExpandClick}
                    aria-expanded={expanded.value}
                    aria-label="show more"
                  >
                    <ExpandMore />
                  </ExpandMoree>
                }
              />
              <Collapse in={expanded.value} timeout="auto" unmountOnExit>
                <CardContent
                  style={{
                    padding: "16px",
                  }}
                >
                  <Grid container>
                    {renderContent()}
                    {renderPaginator()}
                  </Grid>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};

export default EventTable;

const processCounterInfo = (counterInfo) => {
  console.log(counterInfo);
  console.log("here");
  let processedCounterInfo;
  if (counterInfo.water_meter_module_info.water_meter_module_code) {
    processedCounterInfo = {
      serial: counterInfo.water_meter_serial,
      name: counterInfo.water_meter_name,
      moduleInfo: {
        id: counterInfo.water_meter_module_info.water_meter_module_id,
        code: counterInfo.water_meter_module_info.water_meter_module_code,
        name: counterInfo.water_meter_module_info.water_meter_module_name,
      },
    };
  } else {
    processedCounterInfo = {
      serial: counterInfo.water_meter_serial,
      name: counterInfo.water_meter_name,
      moduleInfo: null,
    };
  }
  return processedCounterInfo;
};

const fetchCounterInfo = (utils) => {
  const serial = utils.serial;
  const isLoading = utils.isLoading;
  const counterInfo = utils.counterInfo;

  const data = {
    water_meter_serial: serial,
  };

  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      // console.log("fetch counter info: ", response);
      if (response.data.code == 200) {
        counterInfo.handleChange(processCounterInfo(response.data.data[0]));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const processEvents = (events) => {
  const processedEvents = [];
  events.map((event) => {
    const data = {
      id: event.event_id,
      createdAt: event.event_create_time,
      type: {
        code: event.event_type.event_type_code,
        importance: event.event_type.event_type_importance,
        keyword: event.event_type.event_type_keyword,
      },
      value: event.event_value,
    };
    processedEvents.push(data);
  });
  return processedEvents;
};

const fetchEvents = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const allItems = utils.allItems; // for pagination
  const events = utils.events;
  const moduleCode = utils.moduleCode;

  const data = {
    page: page,
    count: count,
    module_id: null,
    module_code: moduleCode,
  };

  Call("POST", "Event/admin/getAll", data)
    .then((response) => {
      // console.log("get all events: ", response);
      if (response.data.code == 200) {
        const evs = response.data.data;
        /* begin: for pagination */
        if (evs && evs.length !== 0) {
          allItems.handleChange(evs[0]["all_event_count"]);
        }
        /* end: for pagination */
        events.handleChange(processEvents(evs));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
